// extracted by mini-css-extract-plugin
export default {"rating":"HiveRating_rating__XZW0i","icon":"HiveRating_icon__HAbIU","value":"HiveRating_value__S+ikP","label":"HiveRating_label__cWiSb","compact":"HiveRating_compact__93YF7"};